import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { AIConversation } from '../../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'tyson-coaching-conversations';

/**
 * Hook to fetch previous Tyson coaching conversations for the current user.
 * Filters by SalesLiveCoaching conversation type.
 */
export function useTysonCoachingConversations(options?: { enabled?: boolean }) {
	const userSession = useUserSession();
	const userId = userSession.user.id;

	return useQuery({
		queryKey: [BASE_QUERY_KEY, userId],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<AIConversation[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'aiconversation/filter',
				}),
				'POST',
				{
					criteria: [
						{
							property: Api.AIConversationFilterProperty.ConversationType,
							value: Api.AIConversationType.SalesLiveCoaching,
						},
						{
							property: Api.AIConversationFilterProperty.CreatorId,
							value: userId,
						},
					],
					op: Api.FilterOperator.And,
				} satisfies Api.AIConversationFilter
			),
		enabled: options?.enabled ?? true,
		staleTime: 30000, // 30 seconds
	});
}
